import { Preferences } from '@capacitor/preferences';
import React, { useState, useEffect } from "react";
import { 
  FaUser, FaWallet, FaQuestionCircle, 
  FaInfoCircle, FaLock, FaFileContract, 
  FaSignOutAlt, FaPhone
} from "react-icons/fa";
import Navbar from "./navbar";
import BottomBar from "./BottomBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BattleStatsToggle from "./BattleStatsToggle";
import "./My.css"; // New CSS file

const MyProfile = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({ 
    name: "Player", 
    phone_num: "", 
    total_matches: 0,
    winning_rate: 0,
    coins_won: 0,
    total_kills: 0,
    
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get("https://backend.aubattle.com/api/profile", {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });
        setUser(res.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  const handleLogout = async () => {
  await Preferences.remove({ key: 'token' });
  await Preferences.remove({ key: 'user_id' });
  await Preferences.remove({ key: 'role' });
  await Preferences.remove({ key: 'token_expiry' });

  navigate("/");
};

  const menuItems = [
    { icon: <FaUser />, text: "Profile", link: '/profile' },
    { icon: <FaWallet />, text: "Wallet", link: '/mywallet' },
    { icon: <FaPhone />, text: "Contact", link: '/contact' },
    { icon: <FaQuestionCircle />, text: "FAQs", link: '/faqs' },
    { icon: <FaInfoCircle />, text: "About", link: '/about' },
    { icon: <FaLock />, text: "Privacy", link: '/privacy' },
      

   
    { icon: <FaFileContract />, text: "Terms", link: '/Terms' },
  ];

  return (
    <div className="profile-page">
      <Navbar />
      
      <div className="profile-container">
        {loading ? (
          <div className="loading-state">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            {/* Profile Header Section */}
            <div className="profile-header-section">
              
              
              <div className="profile-info-container">
                <h1 className="profile-user-name">{user.name}</h1>
                <p className="profile-user-id">No {user.phone_num || 'Not provided'}</p>
              </div>
            </div>

            {/* Stats Section */}
            <div className="stats-section-wrapper">
              <BattleStatsToggle
                stats={{
                  total_matches: user.total_matches,
                  total_kills: user.total_kills,
                  coins_won: user.coins_won,
                  winning_rate: user.winning_rate,
                }}
              />
            </div>

            {/* Menu Grid */}
            <div className="profile-menu-grid">
              {menuItems.map((item, index) => (
                <div 
                  key={index}
                  className="profile-menu-card"
                  onClick={() => navigate(item.link)}
                >
                  <div className="menu-icon-wrapper">{item.icon}</div>
                  <span className="menu-text-label">{item.text}</span>
                </div>
              ))}
            </div>

            {/* Footer Section */}
            <div className="profile-footer-section">
              <button className="logout-button" onClick={handleLogout}>
                <FaSignOutAlt className="logout-button-icon" />
                <span>Logout</span>
              </button>
              <p className="app-version-text">AUBattle v1.2.0</p>
            </div>
          </>
        )}
      </div>
      
      <BottomBar />
    </div>
  );
};

export default MyProfile;